import React, { useEffect, useState } from 'react';
import { Pagination } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
        '& .MuiPaginationItem-textPrimary.Mui-selected': {
            backgroundColor: '#000000'
        }
    },
}));

function CustomPagination({ totalItem, showPerPage, onPaginationChange, records }) {
    const classes = useStyles();
    const [currentPage, setCurrentPage] = useState(1);

    const handleChange = (event, value) => {
        setCurrentPage(value);
    };

    useEffect(() => {
        if (totalItem < currentPage) {
            setCurrentPage(totalItem);
        }
    }, [totalItem]);

    useEffect(() => {
        setCurrentPage(1);
    }, [records]);

    useEffect(() => {
        // console.log('Show Per Page => ', showPerPage);
        // console.log('Total Item => ', totalItem);
        // if (totalItem === currentPage) {
        //     var latestValue = Math.ceil(records.length / showPerPage)
        //     console.log('Value => ', latestValue);
        //     setCurrentPage(latestValue);
        //     const value = showPerPage * currentPage;
        //     onPaginationChange(value - showPerPage, value);
        // } else {
        //     const value = showPerPage * currentPage;
        //     onPaginationChange(value - showPerPage, value);
        // }

        const value = showPerPage * currentPage;
        onPaginationChange(value - showPerPage, value);
    }, [currentPage, showPerPage]);

    return (
        <>
            <div className={classes.root}>
                <Pagination count={totalItem} page={currentPage} onChange={handleChange} color="primary" />
            </div>
        </>
    )
}

export default CustomPagination
